import React from "react";
import {HeroRightLine} from "../../assets/icons";
import DOMPurify from "dompurify";
import {useLanguage} from "../../hooks/LanguageContext";

const HeroContent = ({ slider }) => {
	const { language } = useLanguage(); // Get current language direction (ltr/rtl)
	const direction = language === 'en' ? 'ltr' : 'rtl';
	const sanitizedTitle = DOMPurify.sanitize(direction === 'rtl' ? slider.title_ar : slider.title_en , {
		ALLOWED_ATTR: ["class"],
	});
	const sanitizedSubTitle = DOMPurify.sanitize(direction === 'rtl' ? slider.subtitle_ar : slider.subtitle_en, {
		ALLOWED_ATTR: ["class"],
	});
	const sanitizedDesc = DOMPurify.sanitize(direction === 'rtl' ? slider.description_ar : slider.description_en, {
		ALLOWED_ATTR: ["class"],
	});

	return (
		<main className="container w-full  px-4 lg:px-32">
			<section
				className={`relative md:w-[706px] w-full md:mt-[240px] mt-2 flex flex-col items-start md:gap-[30px] gap-3 ${
					direction === "rtl" ? "text-right md:mr-8 mr-2" : "text-left md:ml-8 ml-2"
				}`}
			>
				<div
					className="headline-3-ar text-bg-light"
					dangerouslySetInnerHTML={{ __html: sanitizedTitle }}
				></div>
				<h1
					className=" headline-1-ar text-bg-light"
					dangerouslySetInnerHTML={{ __html: sanitizedSubTitle }}
				></h1>
				<p
					className="hidden md:block b1-ar text-bg-darken"
					dangerouslySetInnerHTML={{ __html: sanitizedDesc }}
				></p>
				{ (sanitizedTitle || sanitizedSubTitle || sanitizedDesc) &&
					<HeroRightLine
					className={`absolute md:top-4 top-2 h-36 md:h-auto ${
						direction === "rtl" ? "md:-right-8 -right-5" : "md:-left-8 -left-5"
					}`}
				/> }

			</section>
		</main>
	);
};

export default HeroContent;
